export const RETURNS = 'Returns';
export const DRAWER_DESCRIPTOR_ID = 'returns-drawer-description';
export const DRAWER_CONTENT_LABEL = 'Returns information';
